
// Modified sidebar.jsx
"use client"

import { useState, useEffect } from "react"
import { FiMenu, FiX } from "react-icons/fi"
import Sidebar from "../Sidebar"
import Header from "@/utils/Header"
import HomeView from "./HomeView"
import FoldersView from "./FoldersView"
import HelpView from "../start/Extras/HelpView"
import NotificationsView from "../start/Extras/NotificationsView"
import LanguageView from "../start/Extras/LanguageView"
import ThemesView from "../start/Extras/ThemesView"
import AccountInfoView from "../start/Extras/InformationView"
import PrivacySecurityView from "../start/Extras/PrivacySecurityView"
import PageGoogle from "@/components/start/Google/calendar/page.jsx"
import CasesView from "@/utils/CasesView"
import ChatPage from "../../pages/chat/padreChat"

export default function Dashboard() {
  // Estado inicial para el sidebar - ahora controlado manualmente en todos los dispositivos 
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [showFoldersView, setShowFoldersView] = useState(false)
  const [showHomeView, setShowHomeView] = useState(true)
  const [showNotifications, setShowNotifications] = useState(false)
  const [showFilters, setShowFilters] = useState(false)
  const [showUserProfile, setShowUserProfile] = useState(false)
  const [showChatsView, setShowChatsView] = useState(false)
  const [showHelpView, setShowHelpView] = useState(false)
  const [showThemesView, setShowThemesView] = useState(false)
  const [showNotificationsView, setShowNotificationsView] = useState(false)
  const [showLanguageView, setShowLanguageView] = useState(false)
  const [showAccountInfoView, setShowAccountInfoView] = useState(false)
  const [showPrivacySecurityView, setShowPrivacySecurityView] = useState(false) 

  const [showMeetingsView, setShowMeetingsView] = useState(false);
  const [showCalendarView, setShowCalendarView] = useState(false);
  const [showCasesView, setShowCasesView] = useState(false)
  
  // Control responsivo del sidebar al iniciar
  useEffect(() => {
    // Sidebar abierto por defecto en desktop, cerrado en móvil
    setSidebarOpen(window.innerWidth >= 768);
    
    // No necesitamos el listener para cambios de tamaño de pantalla porque
    // ahora queremos control manual en todos los tamaños de pantalla
  }, []);

  // Toggle sidebar function
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleHomeClick = () => {
    setShowChatsView(false)
    setShowFoldersView(false)
    setShowHomeView(true)
    setShowHelpView(false)
    setShowNotificationsView(false)
    setShowLanguageView(false)
    setShowThemesView(false)
    setShowAccountInfoView(false)
    setShowPrivacySecurityView(false) 
    setShowMeetingsView(false);
    setShowCalendarView(false);
    setShowCasesView(false)
    
    // Ya no cerramos automáticamente en móvil
  }

  // El resto de handlers permanecen igual, pero eliminamos el cierre automático
  const handleChatClick = () => {
    setShowChatsView(true)
    setShowFoldersView(false)
    setShowHomeView(false)
    setShowHelpView(false)
    setShowNotificationsView(false)
    setShowLanguageView(false)
    setShowThemesView(false)
    setShowAccountInfoView(false)
    setShowPrivacySecurityView(false) 
    setShowMeetingsView(false)
    setShowCalendarView(false)
  }
  
  const handleNotificationsClick = () => {
    setShowNotificationsView(true)
    setShowChatsView(false)
    setShowFoldersView(false)
    setShowHomeView(false)
    setShowHelpView(false)
    setShowLanguageView(false)
    setShowAccountInfoView(false)

    setShowPrivacySecurityView(false) 
    setShowMeetingsView(false)
    setShowCalendarView(false)
    setShowThemesView(false)
  }
  
  const handleLanguageClick = () => {
    setShowLanguageView(true)
    setShowNotificationsView(false)
    setShowChatsView(false)
    setShowFoldersView(false)
    setShowHomeView(false)
    setShowHelpView(false)
    setShowThemesView(false)
    setShowAccountInfoView(false)
    setShowPrivacySecurityView(false) 
    setShowMeetingsView(false)
    setShowCalendarView(false)
  }

  const handleThemesClick = () => {
    setShowThemesView(true)
    setShowChatsView(false)
    setShowFoldersView(false)
    setShowHomeView(false)
    setShowHelpView(false)
    setShowNotificationsView(false)
    setShowLanguageView(false)
    setShowAccountInfoView(false)
    setShowPrivacySecurityView(false) 

    setShowMeetingsView(false)
    setShowCalendarView(false)
  }

  const handleAccountInfoClick = () => {
    setShowAccountInfoView(true)
    setShowThemesView(false)
    setShowChatsView(false)
    setShowFoldersView(false)
    setShowHomeView(false)
    setShowHelpView(false)
    setShowNotificationsView(false)
    setShowLanguageView(false)
    setShowPrivacySecurityView(false) 
    setShowMeetingsView(false)
    setShowCalendarView(false)
  }

  const handlePrivacySecurityClick = () => {
    setShowPrivacySecurityView(true)
    setShowAccountInfoView(false)
    setShowThemesView(false)
    setShowChatsView(false)
    setShowFoldersView(false)
    setShowHomeView(false)
    setShowHelpView(false)
    setShowNotificationsView(false)
    setShowLanguageView(false)
    setShowMeetingsView(false)
    setShowCalendarView(false)
  }

  const handleMeetingsClick = () => {
    setShowMeetingsView(true)
    setShowHomeView(false)
    setShowFoldersView(false)
    setShowChatsView(false)
    setShowHelpView(false)
    setShowCalendarView(false)
    setShowNotificationsView(false)
    setShowLanguageView(false)
    setShowThemesView(false)
    setShowAccountInfoView(false)
    setShowPrivacySecurityView(false)
  }

  const handleCalendarClick = () => {
    setShowCalendarView(true)
    setShowHomeView(false)
    setShowFoldersView(false)
    setShowChatsView(false)
    setShowHelpView(false)
    setShowMeetingsView(false)
    setShowNotificationsView(false)
    setShowLanguageView(false)
    setShowThemesView(false)
    setShowAccountInfoView(false)
    setShowPrivacySecurityView(false)
  }

  const handleCasesClick = () => {
    setShowCasesView(true)
    setShowHomeView(false)
    setShowFoldersView(false)
    setShowChatsView(false)
    setShowHelpView(false)
    setShowMeetingsView(false)
    setShowCalendarView(false)
    setShowNotificationsView(false)
    setShowLanguageView(false)
    setShowThemesView(false)
    setShowAccountInfoView(false)
    setShowPrivacySecurityView(false)
  }

  const renderMainContent = () => {
    if (showFoldersView) {
      return <FoldersView />
    }
    if (showChatsView) {
      return <ChatPage />
    }
    if (showHelpView) {
      return <HelpView />
    }
    if (showThemesView){
      return <ThemesView/>
    }
    if (showNotificationsView) {
      return <NotificationsView />
    }
    if (showLanguageView) {
      return <LanguageView />
    }
    if (showAccountInfoView) {
      return <AccountInfoView />
    }
    if (showPrivacySecurityView) {
      return <PrivacySecurityView /> 
    }
    if (showCalendarView) {
      return <PageGoogle />
    }
    // if (showMeetingsView) {
    //   return <MeetingsView />
    // }
    if (showCasesView) {
      return <CasesView />
    }
    if (showHomeView) {
      return <HomeView setShowFoldersView={setShowFoldersView} />
    }
    return <HomeView setShowFoldersView={setShowFoldersView} />
  }

  const toggleNotifications = () => {
    setShowNotifications(!showNotifications)
    if (showFilters) setShowFilters(false)
    if (showUserProfile) setShowUserProfile(false)
  }

  const toggleFilters = () => {
    setShowFilters(!showFilters)
    if (showNotifications) setShowNotifications(false)
    if (showUserProfile) setShowUserProfile(false)
  }

  const toggleUserProfile = () => {
    setShowUserProfile(!showUserProfile)
    if (showNotifications) setShowNotifications(false)
    if (showFilters) setShowFilters(false)
  }

  return (
    <div className="flex h-screen bg-gray-100">
      {/* Mobile overlay - cierra el sidebar al hacer clic fuera (solo en móvil) */}
      {sidebarOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-20 md:hidden"
          onClick={() => setSidebarOpen(false)}
        ></div>
      )}
      
      {/* Sidebar toggle button - now visible on all screen sizes */}
      <button
        onClick={toggleSidebar}
        className="fixed top-4 left-4 z-40 text-navy-900"
        aria-label={sidebarOpen ? "Cerrar menú" : "Abrir menú"}
      >
        {sidebarOpen ? <FiX className="h-6 w-6" /> : <FiMenu className="h-6 w-6" />}
      </button>

      {/* Sidebar - change the styling to be based only on sidebarOpen state */}
      <div className={`bg-white w-64 min-h-screen flex flex-col justify-between transition-all duration-300 ease-in-out fixed ${
        sidebarOpen ? "translate-x-0" : "-translate-x-full"
      } z-30 shadow-lg`}>
        <Sidebar 
          sidebarOpen={sidebarOpen} 
          setSidebarOpen={setSidebarOpen} 
          handleHomeClick={handleHomeClick}
          setShowFoldersView={setShowFoldersView}
          setShowHomeView={setShowHomeView}
          setShowChatsView={setShowChatsView}
          setShowHelpView={setShowHelpView}
          handleNotificationsClick={handleNotificationsClick}
          handleLanguageClick={handleLanguageClick}
          handleThemesClick={handleThemesClick}
          handleAccountInfoClick={handleAccountInfoClick}
          handlePrivacySecurityClick={handlePrivacySecurityClick} 
          handleMeetingsClick={handleMeetingsClick}
          handleCalendarClick={handleCalendarClick}
          handleCasesClick={handleCasesClick}
        />
      </div>

      {/* Main Content */}
      <div className={`flex-1 flex flex-col overflow-hidden transition-all duration-300 ${sidebarOpen ? 'md:ml-64' : 'ml-0'}`}>
        {/* Header */}
        <Header 
          sidebarOpen={sidebarOpen}
          setSidebarOpen={setSidebarOpen}
          showNotifications={showNotifications}
          toggleNotifications={toggleNotifications}
          showFilters={showFilters}
          toggleFilters={toggleFilters}
          showUserProfile={showUserProfile}
          toggleUserProfile={toggleUserProfile}
        />

        {/* Main Content Area */}
        <main className={`flex-1 overflow-y-auto bg-gray-100 ${showChatsView ? 'p-0' : 'p-4'}`}>
          {!showChatsView ? (
            <div className="w-full h-full">
              {renderMainContent()}
            </div>
          ) : (
            renderMainContent()
          )}
        </main>
      </div>
    </div>
  )
}